var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content.title)?_c('h4',[_vm._v(_vm._s(_vm.content.title))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-component",class:_vm.content.settings.size},[_vm._v(_vm._s(_vm.content.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-675bc56e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/PostButtonComponent.vue
// module id = 1915
// module chunks = 5